import MemberBookingRecovery from './MemberBookingRecovery'
import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import React from 'react'

/** Golf's checkout presentation, with domain-owned validation and submission. */
export default function MemberFacilityCheckout({ total, disabled, saving, label, savingLabel, reason, recovery }) {
  const { t } = useOptionalPrivanaI18n()
  return <div className="mp-facility-checkout" role="region" aria-label={label}>
    {recovery?.pending && <MemberBookingRecovery recovery={recovery} />}
    {reason && <p className="mp-text-muted" id="facility-checkout-reason" role="status">{reason}</p>}
    <div className="mp-golf-checkout-total"><span>{t('facilityBooking.total')}</span><strong>{total}</strong></div>
    <button type="submit" className="mp-btn mp-btn--primary" disabled={disabled || saving} aria-describedby={reason ? 'facility-checkout-reason' : undefined} aria-busy={saving}>{saving ? savingLabel : label}</button>
  </div>
}
